import React,{useState,useEffect,useContext,createContext} from 'react'
import {Navigate,useNavigate} from 'react-router-dom'
import '../../css/style.css'
import '../../css/SignUp.css'
import Logo from '../../css/images/logo.png'
import bgImage from '../../css/images/MainBg.png'
import axios from 'axios'
import moment from 'moment'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

export default function SignUp() {

  const [sports,setSports]=useState([])
  const [countries,setCountries]=useState([])
  const [isSaving,setIsSaving]=useState(false)
  const [regObj,setRegObj]=useState({
    Email:'',
    Password:'',
    OtherPassword:'',
    MobilePhone:'',
    NickName:'',
    DateOfBirth:'',
    CountryID:'',
    SportID:'',
    FirstName:'',
    LastName:''
  })
  const [day,setDay]=useState('01')
  const [month,setMonth]=useState('01')
  const [year,setYear]=useState('')
  const [hasErr,setHasErr]=useState(false)
  const [errMsg,setErrMsg]=useState('')
  const [maxRegDate,setMaxRegDate]=useState(null)
  const [iAgree,setIAgree]=useState(false)
  const [years,setYears]=useState([])
  const [parentalContolNeeded,setParentalContolNeeded]=useState(false)

  const navigate=useNavigate ()

  useEffect(()=>{
    loadSports()
    loadCountries()


    let present = new Date()
    let presentDay= present.toISOString().split('T')[0]
    setMaxRegDate(moment(presentDay).subtract(13,'years').format('YYYY-MM-DD'))
    const xyears=[]
    for (let i=present.getFullYear()-13; i>1940;i--){
      xyears.push(i)
    }
    //console.log(moment(presentDay) + ' '+ xyears)
    setYears(xyears)
    //setYear(present.getFullYear()-11)
  },[])

  const months=[
    {monthName:'January',monthNumber:'01'},
    {monthName:'February',monthNumber:'02'},
    {monthName:'March',monthNumber:'03'},
    {monthName:'April',monthNumber:'04'},
    {monthName:'May',monthNumber:'05'},
    {monthName:'June',monthNumber:'06'},
    {monthName:'July',monthNumber:'07'},
    {monthName:'August',monthNumber:'08'},
    {monthName:'September',monthNumber:'09'},
    {monthName:'October',monthNumber:'10'},
    {monthName:'November',monthNumber:'11'},
    {monthName:'December',monthNumber:'12'},
  ]

  const days=['01','02','03','04','05','06','07','08','09','10',
    '11','12','13','14','15','16','17','18','19','20',
    '21','22','23','24','25','26','27','28','29','30','31'
  ]



  const daysList=days.map(d=>{
    return(<option value={d}>{d}</option>)
  })

  const monthsList=months.map(m=>{
    return(<option value={m.monthNumber}>{m.monthName}</option>)
  })

  const yearsList=years.map(y=>{
    return(<option value={y}>{y}</option>)
  })

 const password_show_hide=()=> {
    var x = document.getElementById("floatingPassword");
    var show_eye = document.getElementById("show_eye");
    var hide_eye = document.getElementById("hide_eye");
    hide_eye.classList.remove("d-none");
    if (x.type === "password") {
      x.type = "text";
      show_eye.style.display = "none";
      hide_eye.style.display = "block";
    } else {
      x.type = "password";
      show_eye.style.display = "block";
      hide_eye.style.display = "none";
    }

}


function password_show_hide2() {
  var x = document.getElementById("floatingPassword2");
  var show_eye = document.getElementById("show_eye2");
  var hide_eye = document.getElementById("hide_eye2");
  hide_eye.classList.remove("d-none");
  if (x.type === "password") {
    x.type = "text";
    show_eye.style.display = "none";
    hide_eye.style.display = "block";
  } else {
    x.type = "password";
    show_eye.style.display = "block";
    hide_eye.style.display = "none";
  }
}


const loadSports=()=>{
  axios.get(process.env.REACT_APP_API_SERVER+'sports')
    .then(res=>{

        if (res.data.err==0){
         setSports(res.data.results)
        // console.log(res.data.results)
        }else{
            alert(res.data.msg)
        }

    }).catch(err=>{
      alert("An error has occured, please try again")
    })         
}


const loadCountries=()=>{
  axios.get(process.env.REACT_APP_API_SERVER+'countries')
    .then(res=>{

        if (res.data.err==0){
         setCountries(res.data.results)
         //console.log(res.data.results)
        }else{
            alert(res.data.msg)
        }

    }).catch(err=>{
      alert("An error has occured, please try again")
    })         
}


const sportsList=sports.map(item=>{
  return(
    <option key={item.SportUUID} value={item.SportID}>{item.SportName}</option>
  )
})


const countriesList=countries.map(item=>{
  return(
    <option key={item.UUID} value={item.CountryID}>{item.Country}</option>
  )
})

const register=(e)=>{
  e.preventDefault()
 
  // Validate phone number - must have at least 10 digits (including country code)
  const phoneDigits = (regObj.MobilePhone || '').replace(/\D/g, '')
  if (phoneDigits.length < 10) {
    setHasErr(true)
    setErrMsg('Please enter a valid mobile phone number')
    window.scrollTo({ top: 0, behavior: 'smooth' })
    return
  }

  // Validate sport selection
  if (!regObj.SportID) {
    setHasErr(true)
    setErrMsg('Please select a sport')
    window.scrollTo({ top: 0, behavior: 'smooth' })
    return
  }

  if (parentalContolNeeded && (regObj.Email==regObj.ParentEmail)){
        setIsSaving(false)
        setHasErr(true)
        setErrMsg("Your Email and custodian's Email must be different")    
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        }); 
    
  }else{
      setIsSaving(true)
     // if (regObj.Password==regObj.OtherPassword){
        var endpoint='registerotp'
        if (parentalContolNeeded){
          endpoint='register'
        }
        axios.post(process.env.REACT_APP_API_SERVER+endpoint,regObj)
        .then(async res=>{
            if (res.data.err==0){
                setHasErr(false)
                setErrMsg('')
                localStorage.setItem('SportUUID', sports.filter(item=>item.SportID==regObj.SportID)[0].UUID);
                localStorage.setItem('Email', regObj.Email)
                localStorage.setItem('Password', regObj.Password)

                if (parentalContolNeeded){
                  navigate('/login/activate')
                }else{
                  navigate('/verify-phone', { state: { id:res.data.id,phone:regObj.MobilePhone } })
                }
                
            }else{
              //alert(res.data.msg)
              setHasErr(true)
              setErrMsg(res.data.msg)
              window.scrollTo({
                top: 0,
                behavior: 'smooth' // Optional, for smooth scrolling
              }); 
            }
            setIsSaving(false)
          }).catch(err=>{
            setIsSaving(false)
            setHasErr(true)
            setErrMsg('An error has occured, please try again')
            window.scrollTo({
              top: 0,
              behavior: 'smooth' // Optional, for smooth scrolling
            }); 
            //alert("An error has occured, please try again")
        })
      // }else{
      //   setIsSaving(false)
      //   setHasErr(true)
      //   setErrMsg('Passwords do not match.')   
      //   window.scrollTo({
      //     top: 0,
      //     behavior: 'smooth' // Optional, for smooth scrolling
      //   }); 
      // }
  }
 
  
}
const register1=(e)=>{
  e.preventDefault()
 

  if (parentalContolNeeded && (regObj.Email==regObj.ParentEmail)){
        setIsSaving(false)
        setHasErr(true)
        setErrMsg("Your Email and custodian's Email must be different")    
        window.scrollTo({
          top: 0,
          behavior: 'smooth' // Optional, for smooth scrolling
        }); 
    
  }else{
      setIsSaving(true)
     // if (regObj.Password==regObj.OtherPassword){
        axios.post(process.env.REACT_APP_API_SERVER+'register',regObj)
        .then(async res=>{
            if (res.data.err==0){
                setHasErr(false)
                setErrMsg('')
                localStorage.setItem('SportUUID', sports.filter(item=>item.SportID==regObj.SportID)[0].UUID);
                alert(res.data.id)
                navigate('/verify-phone', { state: { id:res.data.id,phone:regObj.MobilePhone } })
            }else{
              //alert(res.data.msg)
              setHasErr(true)
              setErrMsg(res.data.msg)
              window.scrollTo({
                top: 0,
                behavior: 'smooth' // Optional, for smooth scrolling
              }); 
            }
            setIsSaving(false)
          }).catch(err=>{
            setIsSaving(false)
            setHasErr(true)
            setErrMsg('An error has occured, please try again')
            window.scrollTo({
              top: 0,
              behavior: 'smooth' // Optional, for smooth scrolling
            }); 
            //alert("An error has occured, please try again")
        })
      // }else{
      //   setIsSaving(false)
      //   setHasErr(true)
      //   setErrMsg('Passwords do not match.')   
      //   window.scrollTo({
      //     top: 0,
      //     behavior: 'smooth' // Optional, for smooth scrolling
      //   }); 
      // }
  }
 
  
}

const dateOfBirth=(v,a)=>{

 //console.log(d)
 var d=''
 if (a==1){
  setDay(v)
  d=year + '-'+month+'-'+v
} 
if (a==2){
  setMonth(v)
  d=year+ '-' + v + '-'+ day 
} 
if (a==3){
  v.length>0 ? setYear(v) : setYear(year)
  d=v + '-'+month+'-' + day
} 

const dd=new Date(d)

  if (!isNaN(dd.getTime())){



      var xRegObj={...regObj}
        
        xRegObj.DateOfBirth=d
        //console.log(xRegObj)
        const today=new Date()
        const y=d.split('-')[0]
        const yyyy=today.getFullYear()
        const age=yyyy-y
        
        if (age<17){
          setParentalContolNeeded(true)
        }else{
          setParentalContolNeeded(false)
          //setRegObj({...regObj,ParentEmail:''})
          xRegObj.ParentEmail=''
        }
      // console.log(xRegObj)
        setRegObj({...xRegObj})
  }

}

  const allowedPhoneCountries = countries.map(c => c.CountryCode.toLowerCase() === 'uk' ? 'gb' : c.CountryCode.toLowerCase());

  return (
    <div className="container container-mobile signup-page">
      <div className="div-wrap">
        <div className="box-image">
          <div className="logo"><img src={Logo} alt="logo" /></div>
        </div>
        <div className="form-div">
          <div className="signup-card">
        
        <div className="login-tab-toggle">
          <div className="tab-group">
            <button type="button" onClick={()=>navigate('/login')}>Login</button>
            <button type="button" className="active">Sign Up</button>
          </div>
        </div>

        {!isSaving &&
        <form autoComplete="off" onSubmit={register}>
          {hasErr &&
          <div className="alert alert-danger" role="alert">
          {errMsg}
          </div>                  
          }

          <div className="form-row-custom">
            {/* First Name */}
            <div className="custom-input-group">
              <div className="input-icon"><i className="bi bi-person"></i></div>
              <div className="input-content">
                <div className="input-label">First Name</div>
                <input
                  maxLength={25}
                  type="text"
                  className="underline-input"
                  placeholder="Enter your first name"
                  required
                  value={regObj.FirstName}
                  onChange={(e)=>setRegObj({...regObj,FirstName:e.target.value})}
                />
              </div>
            </div>

            {/* Last Name */}
            <div className="custom-input-group">
              <div className="input-icon"><i className="bi bi-person"></i></div>
              <div className="input-content">
                <div className="input-label">Last Name</div>
                <input
                  maxLength={25}
                  type="text"
                  className="underline-input"
                  placeholder="Enter your last name"
                  required
                  value={regObj.LastName}
                  onChange={(e)=>setRegObj({...regObj,LastName:e.target.value})}
                />
              </div>
            </div>
          </div>

          <div className="form-row-custom">
            {/* Email */}
            <div className="custom-input-group">
              <div className="input-icon"><i className="bi bi-envelope"></i></div>
              <div className="input-content">
                <div className="input-label">Email address</div>
                <input
                  maxLength={64}
                  type="email"
                  className="underline-input"
                  placeholder="you@example.com"
                  required
                  value={regObj.Email.toLowerCase()}
                  onChange={(e)=>setRegObj({...regObj,Email:e.target.value})}
                />
              </div>
            </div>

            {/* Mobile Phone */}
            <div className="custom-input-group">
              <div className="input-icon"><i className="bi bi-telephone"></i></div>
              <div className="input-content">
                <div className="input-label">Mobile number</div>
                {countries.length > 0 &&
                <PhoneInput
                  country={'gr'}
                  onlyCountries={allowedPhoneCountries}
                  value={regObj.MobilePhone}
                  onChange={(phone, data) => {
                    let newCountryID = regObj.CountryID;
                    if (data && data.countryCode) {
                      let code = data.countryCode.toUpperCase();
                      if (code === 'GB') code = 'UK';
                      const matchedCountry = countries.find(c => c.CountryCode === code);
                      if (matchedCountry) {
                        newCountryID = matchedCountry.CountryID;
                      }
                    }
                    setRegObj({...regObj, MobilePhone: phone, CountryID: newCountryID});
                  }}
                  inputClass="custom-phone-input"
                  buttonClass="custom-phone-button"
                  placeholder="Enter your mobile number"
                  inputProps={{ required: true }}
                />
                }
              </div>
            </div>
          </div>

          {/* Password */}
          <div className="custom-input-group">
            <div className="input-icon"><i className="bi bi-lock"></i></div>
            <div className="input-content">
              <div className="input-label">Password</div>
              <div className="password-wrapper">
                <input
                  minLength={6}
                  maxLength={10}
                  type="password"
                  className="underline-input"
                  id="floatingPassword"
                  placeholder="Create a password"
                  required
                  value={regObj.Password}
                  onChange={(e)=>setRegObj({...regObj,Password:e.target.value})}
                />
                <div className="password-eye-icon" onClick={password_show_hide}>
                  <i className="bi bi-eye" id="show_eye"></i>
                  <i className="bi bi-eye-slash d-none" id="hide_eye"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Date of Birth */}
          <div className="custom-input-group">
            <div className="input-icon"><i className="bi bi-calendar"></i></div>
            <div className="input-content">
              <div className="input-label">Date of Birth</div>
              <div className="date-dropdowns">
                <select value={day} onChange={(e)=>dateOfBirth(e.target.value,1)}>{daysList}</select>
                <select value={month} onChange={(e)=>dateOfBirth(e.target.value,2)}>{monthsList}</select>
              </div>
              <div className="date-dropdowns date-dropdowns-year">
                <select required value={year} onChange={(e)=>dateOfBirth(e.target.value,3)}>
                  <option value=''>Year</option>
                  {yearsList}
                </select>
              </div>
            </div>
          </div>

          {parentalContolNeeded &&
          <div className="custom-input-group mt-3">
            <div className="input-icon"><i className="bi bi-envelope-exclamation"></i></div>
            <div className="input-content">
              <div className="input-label"><b>Custodian's Email address</b></div>
              <input
                maxLength={64}
                type="email"
                className="underline-input"
                placeholder="name@example.com"
                required
                value={regObj.ParentEmail}
                onChange={(e)=>setRegObj({...regObj,ParentEmail:e.target.value})}
              />
              <small className="text-muted mt-2">
                In order to follow rules around necessary security measures for your personal data, we need to know that your custodian agrees with you using our application.<br/>
                Typing the email address above means that you have their full consent to use 1,2,3 High App.
              </small>
            </div>
          </div>          
          }

          {/* Country */}
          <div className="custom-input-group mt-3">
            <div className="input-icon"><i className="bi bi-globe"></i></div>
            <div className="input-content">
              <div className="input-label">Country</div>
              <select
                required
                className="underline-input"
                value={regObj.CountryID}
                onChange={(e)=>setRegObj({...regObj,CountryID:e.target.value})}
              >
                <option value=''>[Select Country]</option>
                {countriesList}
              </select>
            </div>
          </div>

          {/* Sport */}
          <div className="custom-input-group mt-3">
            <div className="input-icon"><i className="bi bi-activity"></i></div>
            <div className="input-content">
              <div className="input-label">Sport</div>
              <div className="sport-cards">
                {sports.map(sport => (
                  <div
                    key={sport.SportID}
                    className={`sport-card ${regObj.SportID == sport.SportID ? 'selected' : ''}`}
                    onClick={() => setRegObj({...regObj, SportID: sport.SportID})}
                  >
                    <span className="sport-card-emoji">
                      {sport.SportName === 'Basketball' ? '🏀' : '⚽'}
                    </span>
                    <span className="sport-card-name">{sport.SportName}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Terms */}
          <div className="terms-container mt-4">
            <input type="checkbox" checked={iAgree} onChange={(e)=>setIAgree(e.target.checked)}/>
            <div>
              By creating an account you agree to our <a href="https://onetwothreehigh.com/terms/" target="_blank">Terms of Services</a> and <a href="https://onetwothreehigh.com/privacy/" target="_blank">Privacy Policy</a>
            </div>
          </div>

          <button disabled={!iAgree} type="submit" className={`login-btn-styled ${!iAgree ? 'disabled' : ''}`} style={!iAgree ? {opacity: 0.5, cursor: 'not-allowed'} : {}}>
            Register
            <span className="btn-arrow">→</span>
          </button>
          
          <div className="login-link">
            Already have an account? <span onClick={()=>navigate('/login')}>Login</span>
          </div>

        </form>
        }

        {isSaving &&
          <div className="alert alert-warning mt-3" role="alert">
            Saving, please wait...
          </div>        
        }
          </div>
        </div>
      </div>
    </div>
  )
}
